import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { useIntl } from 'react-intl';
import { Editor } from '../../../../../components/wysiwyg/Editor';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

export const DescriptionCell: FC<WidgetProps> = ({ activityId, activityName, widget: { description } }) => {
	const { setDrawerWithoutPrevParams } = useDrawerContext();
	const intl = useIntl();
	const [editMode, setEditMode] = useState(false);

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.description.type}
			showEditOnHover
			handleEditAction={() => {
				setDrawerWithoutPrevParams('editDescription', { activityId }, () => setEditMode(false));
				setEditMode(true);
			}}
			editMode={editMode}
			tooltipText={intl.formatMessage({ id: 'journey.detail.widget.edit' })}
		>
			{description && <Editor readonly state={description} />}
		</WidgetCell>
	);
};
